import React from 'react';
import ReactDOM from 'react-dom';
import Main from './components/Main';
import { BrowserRouter } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';

ReactDOM.render(
   <BrowserRouter>
      <Main />
   </BrowserRouter>, 
   document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js